module.exports = __webpack_public_path__ + "static/images/ovo.1rDL0_B.svg";